export class Exception extends Error {
    constructor(message, metadata) {
        super(message);
        this.name = self.name;
        if (typeof metadata !== 'undefined') {
            this.metadata = metadata;
        }
    }
}
